import { useState } from "react";

/** Drawer draft: copies the applied filters on open and hands the draft back on Apply. */
export default function useFilterDraft(applied, onApply) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(applied);

  const onOpenChange = (next) => {
    if (next) setDraft(applied);
    setOpen(next);
  };

  const apply = () => {
    onApply(draft);
    setOpen(false);
  };

  return { open, draft, setDraft, onOpenChange, apply };
}
